import * as is from 'utilities/is';

export const visible = annotation => annotation.mode !== 'invisible';

export const inTime = (currentTime, annotation) => afterStart(annotation.start, currentTime) && beforeEnd(annotation.end, currentTime);

export const afterStart = (start, time) => {
    if (!is.truthy(start)) {
        return true;
    }

    return start <= time;
};

export const beforeEnd = (end, time) => {
    if (!is.truthy(end)) {
        return true;
    }

    return end >= time;
};

export const visibleOrInTime = (currentTime, annotation) => visible(annotation) && inTime(currentTime, annotation);
export const compileInScope = (interpreter, annotation) => ({ ...annotation, content: interpreter.compile(annotation.content) });